import React, { useRef } from 'react'

function Contact__me() {
  const contact_me_ref =useRef(null);
  return (
      <div className='bg-[#f5df4e] flex justify-center items-center' ref={contact_me_ref}>
      <div className='md:flex md:flex-row md:justify-between md:items-center flex flex-col justify-center items-center md:ml-[100px] md:mr-[100px] ml-2 mr-2 pt-[100px] pb-[100px]'>
    <div className='md:w-[40%] w-full'>
        <h1 className='font-bold text-[3rem]' style={{fontSize: 'clamp(2rem,4vw,6rem)'}}>Let's get in touch</h1>
        <p className='text-[1.3rem] mt-8 mb-8'>I enjoy discussing new projects and design challenges. Please share as much info, as possible so we can get the most out of our first catch-up.</p>
        <p className='font-semibold text-[1.3rem]'>Living In:</p>
        <p className='mb-6 text-[1.2rem]'>E-03 Sultan calonie DHA Phase 5</p>
        <p className='font-semibold text-[1.3rem]'>Call:</p>
        <p className='text-[1.2rem]'>(+92) 316 4431866</p>
    </div>
    <div className='md:w-[40%] w-full md:pt-0 pt-10 space-y-8'>
    <h1 className='font-bold text-[3rem]' style={{fontSize: 'clamp(2rem,3vw,4rem)'}}>Estimate your Project?</h1>
    <form className='space-y-4'>
        <p> What is Your Name: </p>
        <input type="text" className='border-1 border-black w-full h-10' style={{borderRadius:'5px'}}/>
        <p> Your Email Address: </p>
        <input type="text" className='border-1 border-black w-full h-10' style={{borderRadius:'5px'}}/>
        <p> How can I Help you?:
</p>
        <input type="text" className='border-1 border-black w-full h-10' style={{borderRadius:'5px'}}/>
        <p className='text-center'><button className='border-1 border-black px-10 py-2 hover:bg-black hover:text-white hover:border-white'>Submit</button></p>
    </form>
    </div>
    </div>
    </div>
   
  )
}

export default Contact__me